import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';

export const logoMarquee = groq`{
  _type,
  _key,
  overline,
  logos[] {
    ...(${image}),
    logoWidth,
  },
  'background': background->color.hex,
  'foreground': foreground->color.hex,
}`;

export const SanityLogoMarquee = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('logoMarquee'),
  _key: z.string(),
  overline: z.string().optional().nullable(),
  logos: z.array(SanityImage.extend({ logoWidth: z.number() })),
  background: z.string().optional().nullable(),
  foreground: z.string().optional().nullable(),
});

export type SanityLogoMarquee = z.infer<typeof SanityLogoMarquee>;
